import type { ReactNode } from "react";
import { Card } from "@primereact/ui/card";
import { useAppConfig } from "../../lib/app-config.js";
import { ThemeSelector } from "../ThemeSelector.js";

/** Centered single-card frame for the public auth/setup screens. */
export function AuthLayout({
  title,
  subtitle,
  children,
  wide = false,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  children: ReactNode;
  wide?: boolean;
}) {
  const { branding } = useAppConfig();
  return (
    <div className="relative flex min-h-dvh flex-col items-center justify-center bg-app-background px-4 py-8">
      <div className="absolute right-4 top-4">
        <ThemeSelector compact />
      </div>
      <div className="mb-6 flex items-center gap-2.5">
        <img
          src={branding.logoUrl ?? "/favicon.svg"}
          alt=""
          className="h-10 w-10 object-contain"
        />
        <span className="text-2xl font-semibold tracking-tight text-app-text">
          {branding.name}
        </span>
      </div>
      <Card.Root className={wide ? "w-full max-w-3xl" : "w-full max-w-md"}>
        <Card.Body>
          <Card.Content>
            <h1 className="text-xl font-semibold text-app-text">{title}</h1>
            {subtitle ? (
              <p className="mt-1 text-sm text-app-muted">{subtitle}</p>
            ) : null}
            <div className="mt-6">{children}</div>
          </Card.Content>
        </Card.Body>
      </Card.Root>
    </div>
  );
}
